import { render, staticRenderFns } from "./AddressSelect.vue?vue&type=template&id=357210bf&"
import script from "./AddressSelect.vue?vue&type=script&lang=ts&"
export * from "./AddressSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports